import { Button, Col, Divider, Form, Input, Row, Space } from "antd";
import { useAppDispatch, useAppSelector } from "../../../../util/hooks";
import { useEffect } from "react";
import { AccountState, setModalAlterarSenhaUsuario } from "../../../../redux/slices/account/accountSlice";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { AlterarSenhaUsuarioModel } from "../../../../models/account/chamadas/alterarSenhaUsuarioModel";
import { alterarSenhaUsuario, buscarUsuario } from "../../../../services/accountService";

type AlterarSenhaProps = {
  origem: string;
};

const AlterarSenhaUsuarioModal = ({ origem }: AlterarSenhaProps) => {
  //estados globais
  const accountState = useAppSelector((state) => state.account);
  const pesistedState = useAppSelector((state) => state.persisted);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais
  const [form] = Form.useForm();

  useEffect(() => {}, [accountState.usuario]);

  const submit = (values: AlterarSenhaUsuarioModel) => {
    dispatch(alterarSenhaUsuario({ value: { ...values, idUsuario: origem === "usuario" ? accountState.usuario.id : pesistedState.user.id }, busca: accountState.busca }));
  };

  const voltar = () => {
    dispatch(setModalAlterarSenhaUsuario(false));
  };

  return (
    <>
      <Form form={form} layout="vertical" onFinish={submit}>
        <Row gutter={12}>
          <Col span={24}>
            <Form.Item
              label="Senha"
              name="password"
              rules={[
                {
                  required: true,
                  message: "Digite a nova senha",
                },
              ]}
            >
              <Input type="password" placeholder="Digite sua nova senha" />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label="Confirmar Senha"
              name="confirmPassword"
              rules={[
                {
                  required: true,
                  message: "Digite a confirmação da senha",
                },
              ]}
            >
              <Input type="password" placeholder="Digite a confirmação da senha" />
            </Form.Item>
          </Col>
        </Row>
        <Divider></Divider>
        <Row gutter={12}>
          <Col span={24} className="modalFooter">
            <Space size="middle">
              <Button className="cancelButton" onClick={voltar} icon={<CloseOutlined />}>
                FECHAR
              </Button>
              <Button htmlType="submit" icon={<CheckOutlined />} className="buttonPrimary">
                SALVAR
              </Button>
            </Space>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default AlterarSenhaUsuarioModal;
